/*
 * @Description: 
 * @Autor: jyf
 * @Date: 2022-11-18 08:46:07
 * @LastEditors: jyf
 * @LastEditTime: 2022-12-08 17:45:39
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace PayApi {

    /**
     * 新增应收
     */
    export var Add = (body: AddFeeVM): Promise<any> => {
        return Post(`/msls/Fee/addfee`, body);
    };
    /**
 * 修改费用
 */
    export var Edit = (body: SaveFeeVM): Promise<any> => {
        return Put(`/msls/Fee/updatefee`, body);
    };
    /**
     * 获取费用列表
     */
    export var GetList = (body: GetFeeListPayload): Promise<any> => {
        return Get(`/msls/Fee/GetfeeList?${qs.stringify(body)}`, {});
    };
    /**
 * 导出费用列表
 */
    export var FeeListExport = (body: GetFeeListPayload): Promise<any> => {
        return Download(`/msls/Fee/feelistexport?${qs.stringify(body)}`, {});
    };
    /**
     * 获取账单列表
     */
    export var GetFeeBillList = (body: GetFeeBillListPayload): Promise<any> => {
        return Get(`/msls/FeeBill/getfeebilllist?${qs.stringify(body)}`, {});
    };

    /**
     * 获取账单详情
     */
    export var Getfeebill = (id: string): Promise<any> => {
        return Get(`/msls/FeeBill/getfeebill/${id}`, { id: id });
    };
    /**
     * 获取运单费用列表（用于账单详情）
     */
    export var Getfeecarrierorderlist = (body: GetfeecarrierorderlistPayload): Promise<any> => {
        return Get(`/msls/FeeBill/getfeecarrierorderlist?${qs.stringify(body)}`, {});
    };
    /**
  * 获取运单费用列表（用于账单详情）导出
  */
    export var GetfeecarrierorderlistExport = (body: GetfeecarrierorderlistPayload): Promise<any> => {
        return Download(`/msls/FeeBill/getfeecarrierorderlistExport?${qs.stringify(body)}`, {});
    };
    /**
     * 账单列表导出
     */
    export var Feebilllistexport = (body: GetFeeBillListPayload): Promise<any> => {
        return Download(`/msls/FeeBill/feebilllistexport?${qs.stringify(body)}`, {});
    };
    /**
     * 获取费用列表，添加待对账费用
     */
    export var Getfeelist = (body: GetfeelistPayload): Promise<any> => {
        return Get(`/msls/FeeBill/getfeelist?${qs.stringify(body)}`, {});
    };
    /**
     * 保存账单
     */
    export var SaveBill = (body: SaveFeeBillVM): Promise<any> => {
        return Post(`/msls/FeeBill/SaveBill`, body);
    };
    /**
    * 新增账单
    */
    export var AddFeeBill = (body: any): Promise<any> => {
        return Post(`/msls/FeeBill/addfeebill`, body);
    };
    /**
     * 添加应收账单费用POST
     */
    export var AddFeeBillYS = (body: AddFeeBillExpenseVM): Promise<any> => {
        return Post(`/msls/FeeBill/AddBillExpense`, body);
    };
    /**
     * 获取账单费用列表
     */
    export var GetBillFeeList = (billId: string): Promise<any> => {
        return Get(`/msls/FeeBill/GetBillExpenseList/${billId}`, {});
    };
    /**
     * 删除账单费用
     */
    export var DeleteBillFee = (id: string): Promise<any> => {
        return Delete(`/msls/FeeBill/DeleteBillExpense/${id}`, {});
    };
    /**
     * 修改账单状态 提交审核，审核通过，审核不通过
     */
    export var UpdateBillStatus = (body: UpdateBillStatusVM): Promise<any> => {
        return Put(`/msls/FeeBill/updatebillstatus`, body);
    };
    /**
     * 添加待对账的应付费用至 账单中
     */
    export var AddFeeToBill = (body: AddFeeToBillNM): Promise<any> => {
        return Put(`/msls/FeeBill/AddFeeToBill`, body);
    };
    /**
     * 删除运单费用
     */
    export var DelCoFee = (body: DelCoFeeVM): Promise<any> => {
        return Put(`/msls/FeeBill/DelCoFee`, body);
    };
    /**
     * 删除对账单
     */
    export var DeleteBill = (billid: string): Promise<any> => {
        return Put(`/msls/FeeBill/DeleteBill/${billid}`, {});
    };
    export interface DelCoFeeVM {
        carrierOrderId: string;
        billId: string
    }
    export interface AddFeeToBillNM {
        feeId: string;
        billId: string;
    }

    export interface UpdateBillStatusVM {
        /**
         * 账单id
         */
        id: string;
        /**
         *账单状态"0" | "1" | "2" | "3" | "4"
         */
        feeBillStatus?: string;
    }
    /**
     * 获取账单费用列表
     */
    export interface FeeBillExpenseItemVM {
        id?: string;
        /**
         * 费用类型
         */
        expenseType?: string | null;
        /**
         * 金额
         */
        amount?: number | null;
        /**
         * 费用说明
         */
        expenseExplain?: string | null;
        /**
         * 创建人
         */
        creator?: string | null;
    }
    /**
     * 添加应收账单费用
     */
    export interface AddFeeBillExpenseVM {
        /**
       * 应付账单id
       */
        feeBillId?: string | null;
        /**
         * 金额
         */
        amount?: number | string;
        /**
         * 费用类型
         */
        expenseType?: string | null;
        /**
         * 费用说明
         */
        expenseExplain?: string | null;
    }
    /**
     * 新增账单
     */
    export interface AddFeeBillVM {
        /**
        * 车队id
        */
        carrierId?: string | null;
        /**
         * 车队名字
         */
        carrierName?: string | null;
        /**
         * 客户基地id
         */
        customerBaseId?: string | null;
        /**
         * 客户基地名字
         */
        customerBaseName?: string | null;
        /**
         * 对账周期
         */
        cycle?: any;

    }
    /**
     * 保存账单
     */
    export interface SaveFeeBillVM {
        /**
       * 添加的费用id集合
       */
        addFeeIds?: string[] | null;
        /**
         * 账单id
         */
        billId?: string | null;
        /**
         * 删除的运单id集合
         */
        delCarrierOrderIds?: string[] | null;
        /**
         * 是否审核通过  true 审核通过   false null 执行保存操作
         */
        isAuditPass?: boolean | null;
    }
    /**
     * 获取费用列表，添加待对账费用
     */
    export interface GetfeelistPayload {
        /**
         * 运单编号
         */
        carrierOrderCode: string;
        /**
         * 装运单号
         */
        shipOrderNo: string;
        /**
         * 费用类型
         */
        feeType: string;
        /**
         * 回单状态
         */
        receiptStatus: string | number;
        /**
         * 发货时间
         */
        startDeliveryTime: string;
        /**
         * 发货时间
         */
        endDeliveryTime: string;
        /**
         * 车队id
         */
        carrierId: string;
        asc: boolean;
        orderBy: string;
        skip: number;
        count: number;
    }
    /**
     * 费用列表返回
     */
    export interface FeeItemVM {
        index?: number;
        /**
         * 费用id
         */
        id?: string | null;
        feeStatus?: string;
        /**
         * 费用状态
         */
        feeStatusStr?: string | null;
        /**
         * 费用编号
         */
        feeCode?: string | null;
        /**
         * 费用类型
         */
        feeType?: string | null;
        /**
         * 费用金额
         */
        feeAmount?: number;
        /**
         * 费用说明
         */
        feeExplain?: string | null;
        /**
         * 运单号
         */
        carrierOrderCode?: string | null;
        /**
         * 子运单号  可能存在多个  顿号分割
         */
        subOrderNoes?: string | null;
        /**
         * 装运单号
         */
        shipOrderNo?: string | null;
        /**
         * 原装运单号
         */
        relatedShipOrderNo?: string | null;
        /**
         * 交货单号 可能存在多个  顿号分割
         */
        deliveryOrderNoes?: string | null;
        /**
         * 客户基地
         */
        customerBaseName?: string | null;
        /**
         * 车队名称
         */
        carrierName?: string | null;
        /**
         * 目的地全称
         */
        arrivalAddress?: string | null;
        /**
         * 发货时间
         */
        deliveryTime?: string | null;
        /**
         * 到货时间
         */
        arrivalTime?: string | null;
        carrierOrderStatus?: string;
        /**
         * 运单状态
         */
        carrierOrderStatusStr?: string | null;
        receiptStatus?: string;
        /**
         * 回单状态
         */
        ReceiptStatusStr?: string | null;
    };
    /**
     * 获取运单费用列表（用于账单详情）
     */
    export interface GetfeecarrierorderlistPayload {
        /**
         * 运单编号
         */
        carrierOrderCode: string;
        /**
         * 运单状态
         */
        carrierOrderStatus: string;
        /**
         * 回单状态
         */
        receiptStatus: string;
        /**
         * 账单id
         */
        billId: string;
        asc: boolean;
        orderBy: string;
        skip?: number;
        count?: number
    }
    /**
     * 运单费用列表（用于账单详情）
     */
    export interface FeeCarrierOrderItemVM {
        index?: number;
        /**
       * 运单id
       */
        id?: string;
        /**
         * 运单编号
         */
        carrierOrderCode?: string | null;
        /**
         * 装运单号
         */
        shipOrderNo?: string | null;
        /**
         * 原装运单号
         */
        relatedShipOrderNo?: string | null;
        /**
         * 实际发货时间
         */
        realDeliveryTime?: string;
        /**
         * 含税金额
         */
        includeTaxAmount?: number | null;
        /**
         * 油卡金额
         */
        oilCardAmount?: number | null;
        /**
         * 客诉金额
         */
        customerComplaintAmount?: number | null;
        /**
         * 雨布金额
         */
        waterproofAmount?: number | null;
        /**
         * 其他金额
         */
        otherAmount?: number | null;
        /**
         * 费用合计
         */
        totalAmount?: number | null;
        /**
         * 订单集合
         */
        orderList?:
        Array<FeeOrderItemVM>[]
        | null;
    }
    /**
     * 订单集合数据
     */
    export interface FeeOrderItemVM {
        /**
         * 订单id
         */
        id?: string;
        /**
         * 订单编号
         */
        code?: string | null;
        /**
         * 装货单号
         */
        shiperOrderNo?: string | null;
        /**
         * 交货单号
         */
        deliveryOrderNo?: string | null;
        /**
         * 承运单价
         */
        carrierUnitPrice?: string | null;
        /**
         * 计量系数
         */
        calculationCoefficient?: string | null;
        /**
         * 收货地址
         */
        arrivalAddress?: string | null;
        /**
         * 油卡占比
         */
        oilCardPercent?: number | null;
    };

    /**
     * 获取账单详情
     */
    export interface FeeBillItemVM {
        /**
         * 账单id
         */
        id?: string;
        feeBillStatus?: string;
        /**
         * 账单状态
         */
        feeBillStatusStr?: string | null;
        /**
         * 账单编号
         */
        feeBillCode?: string | null;
        /**
         * 对账周期
         */
        billCycle?: string | null;
        /**
         * 客户基地名字
         */
         customerBaseName?: string | null;
        /**
         * 车队名称
         */
        carrierName?: string | null;
        /**
         * 账单总金额
         */
        totalAmount?: number | null;
        /**
         * 含税金额
         */
        includeTaxAmount?: number | null;
        /**
         * 客诉金额
         */
        customerComplaintAmount?: number | null;
        /**
         * 其他金额
         */
        otherAmount?: number | null;
        /**
         * 油卡金额
         */
        oilCardAmount?: number | null;
        /**
         * 雨布金额
         */
        waterproofAmount?: number | null;
        plateformKind?: string;
        /**
         * 创建方
         */
        plateformKindStr?: string | null;
        /**
         * 创建人
         */
        creator?: string | null;
        /**
         * 创建时间
         */
        creationTime?: string | null;
    };
    /**
     * 获取账单列表
     */
    export interface GetFeeBillListPayload {
        /**
         * 账单状态
         */
        feeBillStatus: string | number;
        /**
         * 账单编号
         */
        feeBillCode: string;
        /**
         * 对账周期
         */
        cycle: string | any;
        /**
   * 客户基地id
   */
        customerBaseId?: string | null;
        /**
         * 客户基地名字
         */
        customerBaseName?: string | null;
        /**
         * 车队
         */
        carrierName: string;

        creationStartTime: string;

        creationEndTime: string;

        carrierId: string;
        asc: boolean;
        orderBy: string | number;
        skip?: number;
        count?: number
    }
    /**
     * 对账单列表数据
     */
    export interface FeeBillItemListVM {
        index?: number;
        /**
         * 账单id
         */
        id?: string;
        feeBillStatus?: string;
        /**
         * 账单状态
         */
        feeBillStatusStr?: string | null;
        /**
         * 账单编号
         */
        feeBillCode?: string | null;
        /**
         * 对账周期
         */
        billCycle?: string | null;
        /**
         * 发货方名字
         */
        shipperName?: string | null;
        /**
         * 车队名称
         */
        carrierName?: string | null;
        /**
         * 账单总金额
         */
        totalAmount?: number | null;
        /**
         * 含税金额
         */
        includeTaxAmount?: number | null;
        /**
         * 客诉金额
         */
        customerComplaintAmount?: number | null;
        /**
         * 其他金额
         */
        otherAmount?: number | null;
        /**
         * 油卡金额
         */
        oilCardAmount?: number | null;
        /**
         * 雨布金额
         */
        waterproofAmount?: number | null;
        plateformKind?: string;
        /**
         * 创建方
         */
        plateformKindStr?: string | null;
        /**
         * 创建人
         */
        creator?: string | null;
        /**
         * 创建时间
         */
        creationTime?: string | null;
    };

    /**
     * 获取费用列表
     */
    export interface GetFeeListPayload {
        /**
         * 费用状态 多选 逗号分割
         */
        feeStatusStr?: string;
        /**
         * 运单编号
         */
        carrierOrderCode?: string;
        /**
         * 子单编号
         */
        subOrderNo?: string;
        /**
         * 装运单号
         */
        shipOrderNo?: string;
        /**
         * 原装运单号
         */
        relatedShipOrderNo?: string;
        originShipOrderNo?:string;
        /**
         * 交货单号
         */
        deliveryOrderNo?: string;
        /**
         * 客户基地名称
         */
        customerBaseName?: string;
        /**
         * 车队名称
         */
        carrierName?: string;
        /**
         * 费用类型
         */
        feeType?: string;
        /**
         * 回单状态
         */
        receiptStatus?: string | number;
        /**
         * 发货时间
         */
        startDeliveryTime?: string;
        /**
         * 发货时间
         */
        endDeliveryTime?: string;

        asc?: boolean;

        orderBy?: string | number;
        skip?: number;
        count?: number;
    };

    /**
     * 费用列表
     */
    export interface FeeItemVM {
        /**
         * 费用id
         */
        id?: string | null;
        feeStatus?: string;
        /**
         * 费用状态
         */
        feeStatusStr?: string | null;
        /**
         * 费用编号
         */
        feeCode?: string | null;
        /**
         * 费用类型
         */
        feeType?: string | null;
        /**
         * 费用金额
         */
        feeAmount?: number;
        /**
         * 费用说明
         */
        feeExplain?: string | null;
        /**
         * 运单号
         */
        carrierOrderCode?: string | null;
        /**
         * 子运单号  可能存在多个  顿号分割
         */
        subOrderNoes?: string | null;
        /**
         * 装运单号
         */
        shipOrderNo?: string | null;
        /**
         * 原装运单号
         */
        relatedShipOrderNo?: string | null;
        /**
         * 交货单号 可能存在多个  顿号分割
         */
        deliveryOrderNoes?: string | null;
        /**
         * 发货方
         */
        shipperName?: string | null;
        /**
         * 车队名称
         */
        carrierName?: string | null;
        /**
         * 目的地全称
         */
        arrivalAddress?: string | null;
        /**
         * 发货时间
         */
        deliveryTime?: string | null;
        /**
         * 到货时间
         */
        arrivalTime?: string | null;
        carrierOrderStatus?: string;
        /**
         * 运单状态
         */
        carrierOrderStatusStr?: string | null;
        receiptStatus?: string;
        /**
         * 回单状态
         */
        receiptStatusStr?: string | null;
    };
    /**
  * 添加费用输入
  */
    export interface AddFeeVM {
        /**
         * 运单Id
         */
        carrierOrderId?: string;
        /**
         * 费用类型
         */
        feeType?: string | null;
        /**
         * 费用金额
         */
        feeAmount?: number;
        /**
         * 费用说明
         */
        feeExplain?: string | null;
    };
    /**
     * 修改费用
     */
    export interface SaveFeeVM {
        id?: string;
        /**
         * 费用类型
         */
        feeType?: string | null;
        /**
         * 费用金额
         */
        feeAmount?: number;
        /**
         * 费用说明
         */
        feeExplain?: string | null;
    }
}
